import { render, staticRenderFns } from "./siteAdminProfileForm.vue?vue&type=template&id=6cfbee7c&scoped=true&"
import script from "./siteAdminProfileForm.vue?vue&type=script&lang=js&"
export * from "./siteAdminProfileForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfbee7c",
  null
  
)

export default component.exports